import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { RestService, ApiQueryParams } from '../lib/RestService';
import { setQueryParams } from '../lib/helpers';
import { BitrixFile } from '../lib/BitrixFile';

export class PaySystem {
  ID: string;
  PAY_SYSTEM_ID?: string;
  NAME: string;
  PSA_NAME: string;
  CODE?: string;
  SORT: string;
  DESCRIPTION?: string;
  PS_MODE?: string;
  HAVE_PRICE: string;
  ACTIVE: string;
  ALLOW_EDIT_PAYMENT: string;
  IS_CASH: string;
  AUTO_CHANGE_1C: string;
  CAN_PRINT_CHECK: string;
  PSA_PERSON_TYPE_ID?: string;
  PSA_ACTION_FILE: string;
  PSA_RESULT_FILE?: string;
  PSA_NEW_WINDOW: string;
  PSA_PARAMS: any;
  PSA_TARIF?: string;
  PSA_HAVE_PAYMENT: string;
  PSA_HAVE_ACTION: string;
  PSA_HAVE_RESULT: string;
  PSA_HAVE_PREPAY: string;
  PSA_HAVE_RESULT_RECEIVE: string;
  PSA_ENCODING?: string;
  PSA_LOGOTIP?: BitrixFile;
  LOGOTIP: BitrixFile;
}

@Injectable()
export class PaySystemService extends RestService {

  private apiUrl = `${environment.apiUrl}shop/PaySystem/`;

  constructor(private http: HttpClient) {
    super();
  }

  public get(params?: ApiQueryParams): Promise<PaySystem[] | any> {
    const apiUrl = setQueryParams(this.apiUrl, params);
    return this.http.get<PaySystem[]>(apiUrl, {withCredentials: true})
      .toPromise()
      .catch(this.handleError);
  }
}
